import {combineEpics} from 'redux-observable';
import alertsConsoleEpic from './alertsConsoleEpic';
import feedbackEpic from './alertFeedbackEpic';

export default combineEpics(alertsConsoleEpic, feedbackEpic);
